module.exports = __webpack_public_path__ + "img/maternite.d3892883.png";